import SummaryBGImg from "app/pages/InteractiveProposal/images/InteractiveProposalSummary.png";
import HexagonImg from "app/pages/InteractiveProposal/images/hexagonImg.png";
import IAppLogoWithText from "app/assets/IAppLogoWithText.png";
import IAPPLogoIcon from "app/assets/IconComponent/IAPPLogoIcon";
import { formatDateWordDateWithoutLocal } from "app/utils/luxon";
import { getProposalType } from "app/utils/utils";

const ircIndexPage = [
  { title: "Summary", number: "1" },
  { title: "Funding", number: "2" },
  { title: "Performance (Post-Credit)", number: "3" },
  { title: "Performance (Pre-Credit)", number: "4" },
  { title: "Signatures", number: "5" },
];

interface IRCIndexPageProps {
  summary: any;
}

const IRCIndexPage = ({ summary }: IRCIndexPageProps) => {
  const entityName = summary?.entity?.title ?? "";
  const proposalNo = summary?.proposalNo ?? "";
  const planType = summary?.planType ?? "";
  const effectiveDate = summary?.planEffectiveDate ?? "";

  return (
    <div className="conthrax-font h-full">
      <div className="flex flex-col items-center text-white h-full justify-between mx-auto">
        {/* Entity name header */}
        <div className="flex items-center pt-4 w-full">
          <div
            className="h-[5px] bg-gradient-to-r from-black to-transparent"
            style={{ width: "30%", marginRight: "-2px" }}
          />
          <h2
            className={`text-[${entityName.length > 70 ? "1.5em" : "1.7em"}] pr-4`}
            style={{
              color: "#091927",
              wordBreak: "break-word",
              overflowWrap: "break-word",
              whiteSpace: "normal",
            }}
          >
            {entityName}
          </h2>
        </div>

        {/* Plan type / proposal no / date hero */}
        <div
          style={{
            backgroundImage: `url(${SummaryBGImg})`,
            backgroundSize: "cover",
            width: "100%",
            height: "49%",
          }}
        >
          <div className="text-center mt-[8em]">
            <h1 className="text-[3em] font-bold tracking-wider uppercase interactive-proposal-text">
              {getProposalType(planType)}
            </h1>
            <h3 className="text-[2em] interactive-proposal-text">Review Center {proposalNo}</h3>
            <div className="text-[2em]" style={{ textShadow: "2px 2px #8f8f8f" }}>
              {effectiveDate ? formatDateWordDateWithoutLocal(effectiveDate) : ""}
            </div>
          </div>
        </div>

        {/* Logo */}
        <div className="flex items-center justify-center gap-[1em]">
          <img src={IAppLogoWithText} alt="IAPP Logo" style={{ height: "7rem" }} />
        </div>

        {/* Table of contents over hexagon background */}
        <div
          style={{
            backgroundImage: `url(${HexagonImg})`,
            backgroundSize: "cover",
            width: "100%",
            height: "49%",
          }}
        >
          <div className="px-[4em] w-full max-w-[56em] mx-auto p-[1.75em]">
            {ircIndexPage.map((item, index) => (
              <div className="relative flex items-center justify-between mb-[1em]" key={index}>
                <div
                  className="text-[1.25em] font-bold tracking-wide z-10 mr-2"
                  style={{ color: "#091927" }}
                >
                  {item.title}
                </div>

                <div
                  className="h-[2px] bg-gradient-to-r from-black to-transparent w-full"
                  style={{ marginRight: "-3px" }}
                />

                <div className="relative z-10 flex items-center justify-center h-[3em] ml-auto mr-[0.75em] conthrax-font">
                  <div className="relative">
                    <svg
                      fill="black"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      width="40px"
                      height="40px"
                      viewBox="0 0 485.688 485.688"
                      xmlSpace="preserve"
                    >
                      <g>
                        <path
                          d="M364.269,453.155H121.416L0,242.844L121.416,32.533h242.853l121.419,210.312L364.269,453.155z"
                          style={{ fill: "white" }}
                        />
                        <g>
                          <path d="M364.269,453.155H121.416L0,242.844L121.416,32.533h242.853l121.419,210.312L364.269,453.155z M131.905,434.997h221.878l110.939-192.152L353.783,50.691H131.905L20.966,242.844L131.905,434.997z" />
                        </g>
                      </g>
                    </svg>
                    <div
                      className="absolute inset-0 flex items-center justify-center conthrax-font"
                      style={{ fontSize: "1.5em", color: "black" }}
                    >
                      {item.number}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Powered by IAPP footer */}
        <div className="mb-[3em] px-[4em] w-full max-w-[56em] mx-auto">
          <div className="flex items-center justify-center">
            <div className="flex-1">
              <div className="bg-gradient-to-r from-black to-transparent h-[2px]" />
            </div>
            <div className="flex items-center mx-2">
              <div className="w-1rem">
                <IAPPLogoIcon fill="black" />
              </div>
              <span
                className="font-semibold whitespace-nowrap ml-[0.5em]"
                style={{ color: "#091927" }}
              >
                Powered by IAPP
              </span>
            </div>
            <div className="flex-1">
              <div className="bg-gradient-to-l from-black to-transparent h-[2px]" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IRCIndexPage;
